import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardOverviewGridRoute extends Route {
  model() {
    return this.modelFor('planning.dashboard');
  }
}

export default instrumentRoutePerformance(PlanningDashboardOverviewGridRoute);
